import Svg, { Path } from 'react-native-svg'

const ProfileIcon = ({ width = 24, height = 24, color = '#000' }: any) => (
  <Svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none">
    <Path
      fill={color}
      fillRule="evenodd"
      d="M16 6a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm4 10.5c0 3.038-3.582 5.5-8 5.5s-8-2.462-8-5.5S7.582 11 12 11s8 2.462 8 5.5Z"
      clipRule="evenodd"
    />
  </Svg>
)
export default ProfileIcon
